module.exports = __webpack_public_path__ + "img/TopState3G.e18750ab.png";